import { z } from 'zod';
import { EXTENDED_VENUE_TYPES } from '@cvent/venue-search-shared/constants/ExtendedVenueType';

export const ExtendedVenueType = z.enum(EXTENDED_VENUE_TYPES);
